import { useCallback, useEffect, useRef } from 'react';
import type { RevieveProduct } from 'revieve';

const getPdpUrl = ({ id, url }: RevieveProduct) => {
  if (url) {
    return url;
  }

  return `${window.location.origin}/products/product?code=${id}`;
};

export const useRedirectToPdp = () => {
  const timeout = useRef<NodeJS.Timeout>();
  useEffect(() => () => clearTimeout(timeout.current));

  return useCallback((product: RevieveProduct, delay = 0) => {
    const redirect = () => window.location.assign(getPdpUrl(product));
    timeout.current = setTimeout(redirect, delay);
  }, []);
};
